import React from 'react'
import './Videopage.css'

function Videopage() {
  return (
    <div>
        This is video page      
    </div>
  )
}

export default Videopage;
